var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu__mobile",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"menu__mobile_button",class:{'active': _vm.active}},[_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }